<template>
  <tk-container class="relative" :status="status" @refresh="init">
    <div
      style="z-index: 9999"
      class="fixed opacity-60 left-15 top-15 square-30 flex-center cursor-pointer rounded-8 bg-white shadow shrink-0"
      slot="header"
      @click="onBack"
    >
      <van-icon name="arrow-left" />
    </div>
    <div class="p-0 w-full h-full">
      <div id="dplayer" class="w-full h-230 bg-black flex-center">
        <van-loading v-if="status === 'loading'" size="24px" color="#fffff">
          加载中...
        </van-loading>
      </div>
      <div class="p-15">
        <!-- 基本信息 -->
        <div class="text-13 font-bold line-height-22 line-2">
          {{ courseData.title }}
        </div>
        <div class="h-4 w-20 bg-orange" />
        <div v-if="subTitle" class="text-11 text-gray mt-8">
          {{ subTitle }}
        </div>
        <!-- 课程目录 -->
        <div class="mt-15 text-13 font-bold line-height-22 line-2">
          课程目录
        </div>
        <div
          id="scrollbar"
          class="scrollbar h-88 overflow-x-scroll mt-15 w-full flex items-center"
        >
          <div
            v-for="(item, index) in videoList"
            :id="`card-video${index}`"
            :key="index"
            :class="[
              active === index
                ? 'border-solid border-orange border text-red bg-white'
                : '',
              index === videoList.length - 1 ? 'mr-0' : 'mr-15'
            ]"
            class="h-88 w-120 flex flex-shrink-0 flex-col justify-between rounded-10 bg-gray-F1F4F8 p-8 text-12 font-400"
            @click="toggleCourse(item, index)"
          >
            <div>
              <div>
                {{ ` 第${index + 1} 课` }}
              </div>
              <div class="mt-5 line-2">
                {{ item.name }}
              </div>
            </div>
            <div v-if="isRecordProgress" class="text-8">
              <div v-if="item.percentage">
                {{
                  item.percentage >= 99
                    ? '已看完'
                    : `上次看到${item.percentage}%`
                }}
              </div>
              <div v-else>上次看到0%</div>
            </div>
          </div>
        </div>
        <!-- 视频详情 -->
        <div v-if="currentVideoDetail" class="mt-15">
          <div class="mb-12 text-13 font-bold line-height-22 line-2">
            视频详情
          </div>
          <div
            class="text-12 text-gray-666 line-height-20"
            v-html="currentVideoDetail"
          />
        </div>
      </div>
    </div>

    <!-- 答题弹窗通过 get-container 动态挂载 -->
    <QuestionDialog
      v-if="currentQuestion"
      :show.sync="showQuestionDialog"
      :question="currentQuestion"
      :is-fullscreen="isFullscreen"
      @complete="handleQuestionComplete"
    />
  </tk-container>
</template>

<script
  type="text/javascript"
  src="https://player.dogecloud.com/js/loader"
></script>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'vant'

export default {
  data() {
    return {
      isWechatIphone: false,
      status: 'loading',
      id: this.$route.query.id,
      courseData: {},
      vcode: this.$route.query.vcode || '',
      player: null,
      startTime: 0,
      videoList: [],
      subTitle: '',
      // 答题相关数据
      showQuestionDialog: false,
      currentQuestion: null,
      isFullscreen: false,
      lastPlayTime: 0,
      isPlaying: false
    }
  },
  computed: {
    ...mapState({
      isRecordProgress: (state) => state.isRecordProgress,
      user: (state) => state.user,
      quizResult: (state) => state.quizResult
    }),
    active() {
      const index = this.videoList.findIndex((s) => {
        return s.vcode === this.vcode
      })
      if (index === -1) {
        return 0
      }
      return index
    },
    poster() {
      const index = this.videoList.findIndex((s) => {
        return s.vcode === this.vcode
      })
      if (index === -1) {
        return ''
      }
      return this.videoList[index].poster || ''
    },
    progress() {
      const index = this.videoList.findIndex((s) => {
        return s.vcode === this.vcode
      })
      if (index === -1) {
        return 0
      }
      return this.videoList[index].progress || 0
    },
    currentVideoDetail() {
      const index = this.videoList.findIndex((s) => {
        return s.vcode === this.vcode
      })
      if (index === -1) {
        return ''
      }
      return this.videoList[index].detail || ''
    }
  },
  created() {
    if (typeof navigator !== 'undefined' && navigator.userAgent) {
      // this.isWechatIphone = true
      this.isWechatIphone =
        /iPhone/i.test(navigator.userAgent) &&
        /MicroMessenger/i.test(navigator.userAgent)
    }
  },
  async activated() {
    // 初始化横竖屏监听
    this.updateOrientation()
    window.addEventListener('resize', this.updateOrientation)
    window.addEventListener('orientationchange', this.updateOrientation)

    // 检查是否有答题结果返回
    let isQuizReturn = false
    if (this.quizResult) {
      isQuizReturn = true
      this.handleQuestionComplete(this.quizResult)
      this.setQuizResult(null)
    }

    // 如果播放器存在,说明是从答题页返回,不需要重新初始化
    if (this.player) {
      // 如果是从答题页返回,且是微信 iPhone 环境,尝试恢复全屏播放
      if (isQuizReturn && this.isWechatIphone) {
        // 延时确保播放器初始化完成
        setTimeout(() => {
          this.player.dp.fullScreen.request('browser')
          // 确保播放
          this.player.play()
        }, 500)
      }
      return
    }

    await this.init()
  },
  async beforeRouteLeave(to, from, next) {
    // 清理横竖屏监听
    window.removeEventListener('resize', this.updateOrientation)
    window.removeEventListener('orientationchange', this.updateOrientation)

    try {
      if (this.isRecordProgress) {
        await this.recordTime()
      }
      // 如果跳转到答题页,不销毁播放器
      if (to.path === '/course/question') {
        if (this.player) {
          this.player.pause()
        }
        next(true)
        return
      }
      if (this.player) {
        this.player.pause()
        this.player.destroy()
        this.player.dp.destroy()
        this.player = null
      }
    } catch (e) {
      next(true)
      throw e
    }
    next(true)
  },
  methods: {
    ...mapMutations(['setCurrentQuiz', 'setQuizResult']),
    async init() {
      await this.getDetail()
      if (this.isRecordProgress) {
        await this.initCatalogueProgress()
      }
      this.status = false
      this.domScrollClient()
      this.initPlayer(this.active)
    },
    onBack() {
      this.$back()
    },
    async getDetail() {
      const { data: res } = await this.$tkParse
        .get(`/classes/courseList/${this.id}`)
        .catch(async (e) => {
          Toast({
            message: '该课程不存在，即将返回',
            position: 'bottom'
          })
          await this.$tkHelper.promiseTimeout(1000)
          this.$back()
        })
      res.courseCatalog = res.courseCatalog || {
        type: false,
        list: [
          {
            title: '',
            list: []
          }
        ]
      }
      this.courseData = res
      if (this.courseData.courseCatalog.type) {
        let list = this.courseData.courseCatalog.list.filter((s) => {
          let index = s.list.findIndex((m) => m.vcode === this.vcode)
          return index !== -1
        })
        if (list.length) {
          this.videoList = list[0].list
          this.subTitle = list[0].title
        }
        return
      }
      if (this.courseData.courseCatalog.list.length) {
        this.videoList = this.courseData.courseCatalog.list[0].list
      }
    },
    // | 同步目录中的学习进度
    async initCatalogueProgress() {
      const batchRequest = []
      this.videoList.forEach((s) => {
        s.percentage = 0
        s.progress = 0
      })
      for (let i = 0; i < this.videoList.length; i++) {
        const request = this.$tkParse.getList('/classes/recordProgress', {
          params: {
            limit: 1,
            order: '-createdAt',
            where: {
              user: this.user.objectId,
              course: this.id,
              vcode: this.videoList[i].vcode
            }
          }
        })
        batchRequest.push(request)
      }
      const result = await Promise.all(batchRequest)
      for (let i = 0; i < this.videoList.length; i++) {
        if (result[i].length) {
          this.videoList[i].percentage = result[i][0].percentage || 0
          this.videoList[i].progress = result[i][0].progress || 0
        } else {
          this.videoList[i].percentage = 0
          this.videoList[i].progress = 0
        }
      }
      this.$forceUpdate()
    },
    async initPlayer(index) {
      if (!this.vcode) {
        return
      }
      if (this.player) {
        this.player.pause()
        this.player.destroy()
        this.player.dp.destroy()
        this.player = null
      }
      this.player = new DogePlayer({
        container: document.getElementById('dplayer'),
        userId: 13974,
        // 测试userId
        // userId: 9340,
        vcode: this.vcode,
        start: this.progress,
        pic: this.poster,
        loop: true,
        autoPlay: true,
        switcher: {
          full: true,
          webfull: true
        },
        events: {
          ready: async (p) => {
            if (this.$tkUa.isIos) {
              this.player.seek(this.progress)
              this.player.notice(`快进 ${Math.floor(this.progress)} 秒`, 2)
              return
            }
            this.player.pause()
            await this.$tkHelper.sleep(500)
            this.player.play()
            await this.$tkHelper.sleep(1000)
            if (this.player.playTime < this.progress) {
              this.player.seek(this.progress)
              this.player.notice(`快进 ${Math.floor(this.progress)} 秒`, 2)
            }
          },
          error: async (p) => {
            Toast({
              message: '视频加载失败',
              position: 'bottom'
            })
            await this.$tkHelper.sleep(1000)
            this.$back()
          },
          second: (second, p) => {
            // 监听播放时间，检查是否需要触发答题
            this.checkQuestionTrigger(second)
          },
          fullscreen: (isFullscreen, p) => {
            // 播放器全屏状态变化时也更新横竖屏判断
            this.updateOrientation()
          },
          play: () => {
            this.isPlaying = true
            this.lastPlayTime = Date.now()
          },
          pause: () => {
            this.isPlaying = false
          },
          seek: () => {
            this.lastPlayTime = Date.now()
          }
        }
      })
    },
    // | 初始化将目录在可视区域展示
    domScrollClient() {
      const dom = document.getElementById('scrollbar')
      if (!dom) {
        return
      }
      const card = document.getElementById(`card-video${this.active}`)
      if (!card) {
        return
      }
      dom.scrollTo({
        left: card.offsetLeft - 100,
        behavior: 'smooth'
      })
    },
    // | 切换课
    async toggleCourse(item, index) {
      if (index === this.active) {
        return
      }
      this.vcode = this.videoList[index].vcode
      // 可视区域
      const dom = document.getElementById('scrollbar')
      if (!dom) {
        return
      }
      const card = document.getElementById(`card-video${index}`)
      if (!card) {
        return
      }
      // 添加动画
      dom.scrollTo({
        left: card.offsetLeft - 100,
        behavior: 'smooth'
      })
      // 重新初始化播放器加载新视频
      await this.initPlayer(index)
    },
    // | 返回记录观看时长
    async recordTime() {
      if (!this.player) {
        return
      }
      let time = this.player.playTime ? this.player.playTime : 0
      if (time < 10) {
        return
      }
      // 保留两位的小数
      const progressPercentage = (time / this.player.duration) * 100
      await this.$tkParse.post('/classes/recordProgress', {
        user: this.user.objectId,
        course: this.id,
        vcode: this.vcode,
        progress: this.player.playTime,
        percentage: Math.round(progressPercentage * 100) / 100
      })
    },
    // | 检查是否触发答题
    checkQuestionTrigger(currentTime) {
      // questions 字段可能不存在，且弹窗打开时不重复触发
      if (!this.player || this.showQuestionDialog) {
        return
      }

      // 仅在播放状态，且开始播放一秒钟以上时才进行答题判断
      if (!this.isPlaying || Date.now() - this.lastPlayTime < 1000) {
        return
      }

      const currentVideo = this.videoList.find(
        (item) => item.vcode === this.vcode
      )
      if (
        !currentVideo ||
        !Array.isArray(currentVideo.questions) ||
        !currentVideo.questions.length
      ) {
        return
      }

      // 检查是否有题目需要在当前时间触发
      const question = currentVideo.questions.find(
        (q) => q.time === currentTime
      )

      if (question) {
        this.currentQuestion = question
        // 暂停视频
        this.player.pause()
        if (this.isWechatIphone && this.isFullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen()
          } else if (document.webkitExitFullscreen) {
            // Safari / Chrome
            document.webkitExitFullscreen()
          } else if (document.mozCancelFullScreen) {
            // Firefox
            document.mozCancelFullScreen()
          } else if (document.msExitFullscreen) {
            // IE/Edge
            document.msExitFullscreen()
          }
          // 微信 iPhone 全屏模式下，跳转新页面答题
          this.setCurrentQuiz(question)
          this.$router.push('/course/question')
        } else {
          // 默认弹窗答题
          this.showQuestionDialog = true
        }
      }
    },
    // | 处理答题完成
    async handleQuestionComplete(result) {
      this.showQuestionDialog = false
      // 继续播放视频
      if (this.player) {
        this.player.play()
      }
      // 保存或更新当前视频的答题记录（按题目维度更新）
      try {
        await this.saveAnswerRecord(result)
      } catch (e) {
        // 记录错误但不打断用户观看
        // eslint-disable-next-line no-console
        console.error('保存答题记录失败', e)
      }
    },
    // | 更新横竖屏状态
    updateOrientation() {
      // 通过浏览器宽高判断横竖屏:宽度大于高度则为横屏(全屏)
      this.isFullscreen = window.innerWidth > window.innerHeight
    },
    // | 保存/更新答题记录(answerRecord),每个视频只保留一条记录
    async saveAnswerRecord(result) {
      if (!this.user || !this.user.objectId) {
        return
      }

      const currentVideo = this.videoList.find(
        (item) => item.vcode === this.vcode
      )
      if (
        !currentVideo ||
        !Array.isArray(currentVideo.questions) ||
        !currentVideo.questions.length
      ) {
        return
      }

      const totalQuestions = currentVideo.questions.length
      if (
        !this.currentQuestion ||
        !this.currentQuestion.id ||
        !totalQuestions
      ) {
        return
      }

      // 当前题目的作答结果
      const selectedOptionIds = Array.isArray(result.userAnswer)
        ? result.userAnswer
        : result.userAnswer
        ? [result.userAnswer]
        : []

      const currentQuestionDetail = {
        questionId: this.currentQuestion.id,
        selectedOptionIds,
        isCorrect: !!result.isCorrect
      }

      // 查询当前「用户 + 课程 + 视频」是否已有答题记录
      const where = {
        user: this.user.objectId,
        course: this.id,
        vcode: this.vcode
      }
      let existRecord = null
      try {
        const list = await this.$tkParse.getList('/classes/answerRecord', {
          params: {
            limit: 1,
            where
          }
        })
        if (Array.isArray(list) && list.length) {
          existRecord = list[0]
        }
      } catch (e) {
        // 查询失败时不进行后续保存，避免误覆盖
        // eslint-disable-next-line no-console
        console.error('查询答题记录失败', e)
        return
      }

      // 基于后端已有的 detail.questions 做按题目维度的更新
      const validQuestionIds = currentVideo.questions.map((q) => q.id)
      let questionDetails = []
      if (
        existRecord &&
        existRecord.detail &&
        typeof existRecord.detail === 'object'
      ) {
        const existQuestions = Array.isArray(existRecord.detail.questions)
          ? existRecord.detail.questions
          : []
        // 只保留仍然存在于当前视频 questions 中的历史题目记录
        questionDetails = existQuestions.filter((item) =>
          validQuestionIds.includes(item.questionId)
        )
      }

      const existIndex = questionDetails.findIndex(
        (item) => item.questionId === currentQuestionDetail.questionId
      )
      if (existIndex > -1) {
        questionDetails.splice(existIndex, 1, currentQuestionDetail)
      } else {
        questionDetails.push(currentQuestionDetail)
      }

      const answeredQuestions = questionDetails.length
      const correctQuestions = questionDetails.filter(
        (item) => item.isCorrect
      ).length
      // 正确率类似完成率：按总题目数计算，例如 1/3 ≈ 33%
      const accuracyRate =
        totalQuestions > 0
          ? Math.round((correctQuestions / totalQuestions) * 100)
          : 0

      const detail = {
        totalQuestions,
        answeredQuestions,
        correctQuestions,
        accuracyRate,
        questions: questionDetails
      }

      // 每个视频只存在一条 answerRecord：有则更新，无则创建
      if (existRecord && existRecord.objectId) {
        await this.$tkParse.put(
          `/classes/answerRecord/${existRecord.objectId}`,
          {
            accuracyRate,
            detail
          }
        )
      } else {
        await this.$tkParse.post('/classes/answerRecord', {
          user: this.user.objectId,
          course: this.id,
          vcode: this.vcode,
          accuracyRate,
          detail
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
video {
  height: 230px;
  width: 100%;
}
</style>
<style>
.dplayer-download {
  display: none;
}
</style>
